<template>
  <div id="app">
    <div id="ontop">
      <div style="padding: 0 30px 0 30px">
      <img class="img-oval"  src="https://i.pinimg.com/originals/7a/06/3f/7a063f4d6cb1a218a178bbaf438a5b10.jpg" alt="Avatar" style="width:50px">
      <span style="margin-left: 5px;margin-top: 3px" class="mpt-color">Mai Phuong Express</span>
      </div>
      <div id="nav">
        <MenuBar msg="abcd"/>
      </div>
    </div>
    <div id="topapp">
      <router-view/>
    </div>
  </div>
</template>
<script>

import MenuBar from "@/components/MenuBar.vue";
import Constants from "@/components/Constants/Constants.js"

export default {
    name: 'NewPage',
    components: {
    MenuBar
  },
  created(){
    if(this.$route.name != "Home"){
      return;
    }
            localStorage.setItem(Constants.ITEM_THONG_TIN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HOME,"nav-bar active");
            localStorage.setItem(Constants.ITEM_VAN_CHUYEN,"nav-bar");
            localStorage.setItem(Constants.ITEM_HANG_XACH_TAY,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_VN,"nav-bar");
            localStorage.setItem(Constants.ITEM_CHI_NHANH_JP,"nav-bar");
    console.log("app",this.$route);
    
  }
}
</script>
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}

#nav {
  padding:0 30px 0px 30px;
  z-index: -1 !important;
  /* position: relative; */
}

#nav a {
  font-weight: bold;
}
#ontop {
  width: 100%;
  height: 140px;
  background:white;
  position: fixed;
  top: 0px;
  border-bottom-style: solid;
  border-bottom-color: #f73667;
  z-index: 99 !important;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
.mpt-color{
  color: #f73667;
  font-size: 20px;
}
.img-oval {
  margin-top:5px ;
  margin-bottom: 5px;
  border-radius: 50%;
}
#topapp{
  z-index: 1;
}
</style>

